import { Box } from '@mui/material';
import { FC } from 'react';
import JobsTable from './JobsTable';

type Props = {
  indexId: string;
  opporId?: number;
};

const JobsMain: FC<Props> = ({ indexId, opporId }) => {
  return (
    <Box>
      <JobsTable indexId={indexId} opporId={opporId} />
    </Box>
  );
};

export default JobsMain;
